import type { CadastroBannerFornecedorModel } from "../models/cadasBannerFornecedorModel"
import { CadastroBannerFornecedorActionsTypes } from "./cadasBannerFornecedorActions"
import type { CadastroBannerFornecedorActions } from "./cadasBannerFornecedorActions"

const {
    CARREGAR,
    SET_URL_BANNER,
    SET_EXIBIR_CARDAPIO,
    SET_EXIBIR_TELA_INICIAL,
    ADICIONAR_BANNER,
    REMOVER_BANNER,
    RESETAR_FORM,
} = CadastroBannerFornecedorActionsTypes

export function cadasBannerFornecedorReducer(
    state: CadastroBannerFornecedorModel,
    action: CadastroBannerFornecedorActions
): CadastroBannerFornecedorModel {
    switch (action.type) {
        case CARREGAR:
            return {
                ...state,
                banners: action.payload.banners,
                podeCriarBannerTelaInicial: action.payload.podeCriarBannerTelaInicial,
                novoUrlBanner: null,
                novoExibirCardapio: false,
                novoExibirTelaInicial: false,
            }

        case SET_URL_BANNER:
            return { ...state, novoUrlBanner: action.payload }

        case SET_EXIBIR_CARDAPIO:
            return { ...state, novoExibirCardapio: action.payload }

        case SET_EXIBIR_TELA_INICIAL:
            return { ...state, novoExibirTelaInicial: action.payload }

        case ADICIONAR_BANNER:
            return {
                ...state,
                banners: [...state.banners, action.payload],
                novoUrlBanner: null,
                novoExibirCardapio: false,
                novoExibirTelaInicial: false,
            }

        case REMOVER_BANNER:
            return {
                ...state,
                banners: state.banners.filter(b => b.id !== action.payload),
            }

        case RESETAR_FORM:
            return {
                ...state,
                novoUrlBanner: null,
                novoExibirCardapio: false,
                novoExibirTelaInicial: false,
            }

        default:
            return state
    }
}
